module.exports = __webpack_public_path__ + "static/media/Asset 9.2@3x.86a8ba4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Avatar/Asset 9.2@3x.png
// module id = 2405
// module chunks = 0